import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/ars',
    component: Layout,
    redirect: '/ars/article',
    name: 'ars',
    meta: {title: '文章', icon: 'article'},
    children: [{
      path: 'article',
      name: 'article',
      component: () => import('@/views/ars/article/index'),
      meta: {title: '新闻列表', icon: 'product-list'}
    },
      {
        path: 'addArticle',
        name: 'addArticle',
        component: () => import('@/views/ars/article/add'),
        meta: {title: '添加文章', icon: 'product-add'}
      },
      {
        path: 'updateArticle',
        name: 'updateArticle',
        component: () => import('@/views/ars/article/update'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },
      {
        path: 'articleCate',
        name: 'articleCate',
        component: () => import('@/views/ars/articleCate/index'),
        meta: {title: '新闻分类', icon: 'article-cate'}
      },
      {
        path: 'addArticleCate',
        name: 'addArticleCate',
        component: () => import('@/views/ars/articleCate/add'),
        meta: {title: '添加新闻分类'},
        hidden: true
      },
      {
        path: 'updateArticleCate',
        name: 'updateArticleCate',
        component: () => import('@/views/ars/articleCate/update'),
        meta: {title: '修改新闻分类'},
        hidden: true
      },
      {
        path: 'creathtml',
        name: 'creathtml',
        component: () => import('@/views/ars/article/creathtml'),
        meta: {title: '静态页面生成'},
        hidden: true
      }
      ,
      {
        path: 'updateclick',
        name: 'updateclick',
        component: () => import('@/views/ars/article/updateclick'),
        meta: {title: '更新文章浏览量'},
        hidden: true
      }
    ]
  },
  {
    path: '/mau',
    component: Layout,
    redirect: '/mau/manuscript',
    name: 'mau',
    meta: {title: '投稿', icon: 'manuscript'},
    children: [{
      path: 'manuscript',
      name: 'manuscript',
      component: () => import('@/views/mau/manuscript/index'),
      meta: {title: '审核列表', icon: 'product-list'}
    },{
      path: 'showManuscript',
      name: 'showManuscript',
      component: () => import('@/views/mau/manuscript/verify'),
      meta: {title: '已过投稿', icon: 'product-list'}
    },
      {
        path: 'addManuscript',
        name: 'addManuscript',
        component: () => import('@/views/mau/manuscript/add'),
        meta: {title: '添加文章', icon: 'product-add'}
      },
      {
        path: 'updateManuscript',
        name: 'updateManuscript',
        component: () => import('@/views/mau/manuscript/update'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },{
        path: 'report',
        name: 'report',
        component: () => import('@/views/mau/report/index'),
        meta: {title: '文章列表', icon: 'product-list'}
      },
      {
        path: 'updateReport',
        name: 'updateReport',
        component: () => import('@/views/mau/report/update'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },{
        path: 'proposal',
        name: 'proposal',
        component: () => import('@/views/mau/proposal/index'),
        meta: {title: '文章列表', icon: 'product-list'}
      },
      {
        path: 'updateProposal',
        name: 'updateProposal',
        component: () => import('@/views/mau/proposal/update'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      }
    ]
  },
  {
    path: '/drj',
    component: Layout,
    redirect: '/drj/juanzeng',
    name: 'drj',
    meta: {title: '大额捐赠', icon: 'juanzeng'},
    children: [{
      path: 'juanzeng',
      name: 'juanzeng',
      component: () => import('@/views/drj/juanzeng/index'),
      meta: {title: '审核列表', icon: 'product-list'}
    },{
      path: 'showJuanzeng',
      name: 'showJuanzeng',
      component: () => import('@/views/drj/juanzeng/verify'),
      meta: {title: '已过投稿', icon: 'product-list'}
    },
      {
        path: 'addJuanzeng',
        name: 'addJuanzeng',
        component: () => import('@/views/drj/juanzeng/add'),
        meta: {title: '添加文章', icon: 'product-add'}
      },
      {
        path: 'updateJuanzeng',
        name: 'updateJuanzeng',
        component: () => import('@/views/drj/juanzeng/update'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },
      {
        path: 'updateGerenJuanzeng',
        name: 'updateGerenJuanzeng',
        component: () => import('@/views/drj/juanzeng/updateGeren'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },
      {
        path: 'updateQiyeJuanzeng',
        name: 'updateQiyeJuanzeng',
        component: () => import('@/views/drj/juanzeng/updateQiye'),
        meta: {title: '修改文章', icon: 'article-add'},
        hidden: true
      },
      {
        path: 'addGeren',
        name: 'addGeren',
        component: () => import('@/views/drj/juanzeng/addGeren'),
        meta: {title: '添加文章', icon: 'article-add'},
        hidden: true
      },
      {
        path: 'addQiye',
        name: 'addQiye',
        component: () => import('@/views/drj/juanzeng/addQiye'),
        meta: {title: '添加文章', icon: 'article-add'},
        hidden: true
      }
    ]
  },
  {
    path:'/rec',
    component: Layout,
    redirect: '/rec/Hometop',
    name: 'rec',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'Hometop',
        name: 'Hometop',
        component: () => import('@/views/rec/hometop/index'),
        meta: {title: '推荐列表', icon: 'sms-ad'}
      },
      {
        path: 'Listtop',
        name: 'Listtop',
        component: () => import('@/views/rec/listtop/index'),
        meta: {title: '频道头条推荐', icon: 'sms-ad'}
      },
      {
        path: 'Clicktop',
        name: 'Clicktop',
        component: () => import('@/views/rec/clicktop/index'),
        meta: {title: '点击量推荐', icon: 'sms-ad'}
      },
      {
        path: 'sexRecTop',
        name: 'sexRecTop',
        component: () => import('@/views/rec/hometop/sexRecTop'),
        meta: {title: '竖条推荐'},
        hidden:true
      },
      {
        path: 'latestNews',
        name: 'latestNews',
        component: () => import('@/views/rec/hometop/latestNews'),
        meta: {title: '最新要闻'},
        hidden:true
      },
      {
        path: 'addHometop',
        name: 'addHometop',
        component: () => import('@/views/rec/hometop/add'),
        meta: {title: '添加推荐'},
        hidden:true
      },
      {
        path: 'updateHometop',
        name: 'updateHometop',
        component: () => import('@/views/rec/hometop/update'),
        meta: {title: '编辑推荐'},
        hidden:true
      }
      ,
      {
        path: 'addListtop',
        name: 'addListtop',
        component: () => import('@/views/rec/listtop/add'),
        meta: {title: '添加推荐'},
        hidden:true
      },
      {
        path: 'updateListtop',
        name: 'updateListtop',
        component: () => import('@/views/rec/listtop/update'),
        meta: {title: '编辑推荐'},
        hidden:true
      }
    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      },
      {
        path: 'dzb',
        name: 'homeDzb',
        component: () => import('@/views/sms/dzb/index'),
        meta: {title: '电子报列表', icon: 'sms-dzb'}
      },

      {
        path: 'addDzb',
        name: 'addHomeDzb',
        component: () => import('@/views/sms/dzb/add'),
        meta: {title: '添加电子报'},
        hidden:true
      },
      {
        path: 'updateDzb',
        name: 'updateDzb',
        component: () => import('@/views/sms/dzb/update'),
        meta: {title: '编辑电子报'},
        hidden:true
      },
      {
        path: 'activity',
        name: 'homeActivity',
        component: () => import('@/views/sms/activity/index'),
        meta: {title: '活动列表', icon: 'sms-activity'}
      },

      {
        path: 'addActivity',
        name: 'addHomeActivity',
        component: () => import('@/views/sms/activity/add'),
        meta: {title: '添加活动'},
        hidden:true
      },
      {
        path: 'updateActivity',
        name: 'updateActivity',
        component: () => import('@/views/sms/activity/update'),
        meta: {title: '编辑活动'},
        hidden:true
      }
      ,
      {
        path: 'zhuantilist',
        name: 'homeZhuantilist',
        component: () => import('@/views/sms/zhuantilist/index'),
        meta: {title: '专题列表', icon: 'sms-activity'}
      },

      {
        path: 'addZhuantilist',
        name: 'addHomeZhuantilist',
        component: () => import('@/views/sms/zhuantilist/add'),
        meta: {title: '添加专题'},
        hidden:true
      },
      {
        path: 'updateZhuantilist',
        name: 'updateZhuantilist',
        component: () => import('@/views/sms/zhuantilist/update'),
        meta: {title: '编辑专题'},
        hidden:true
      }
      ,
      {
        path: 'lh',
        name: 'homeLsh',
        component: () => import('@/views/sms/lsh/index'),
        meta: {title: '理事列表', icon: 'sms-activity'}
      },

      {
        path: 'addLsh',
        name: 'addHomeLsh',
        component: () => import('@/views/sms/lsh/add'),
        meta: {title: '添加理事'},
        hidden:true
      },
      {
        path: 'updateLsh',
        name: 'updateLsh',
        component: () => import('@/views/sms/lsh/update'),
        meta: {title: '编辑理事'},
        hidden:true
      }

    ]
  },
  {
    path:'/shsw',
    component: Layout,
    redirect: '/shsw/index',
    name: 'shsw',
    meta: {title: '社会事务', icon: 'shsw'},
    children: [
      {
        path: 'index',
        name: 'homeShsw',
        component: () => import('@/views/shsw/activity/index'),
        meta: {title: '列表', icon: 'sms-activity'}
      },
      {
        path: 'addShsw',
        name: 'addHomeShsw',
        component: () => import('@/views/shsw/activity/add'),
        meta: {title: '添加文章'},
        hidden:true
      },
      {
        path: 'updateShsw',
        name: 'updateShsw',
        component: () => import('@/views/shsw/activity/update'),
        meta: {title: '编辑文章'},
        hidden:true
      },
      {
        path: 'dzb',
        name: 'homeDzb',
        component: () => import('@/views/shsw/dzb/index'),
        meta: {title: '电子报列表', icon: 'sms-dzb'}
      },
      {
        path: 'addDzb',
        name: 'addHomeDzb',
        component: () => import('@/views/shsw/dzb/add'),
        meta: {title: '添加电子报'},
        hidden:true
      },
      {
        path: 'updateDzb',
        name: 'updateDzb',
        component: () => import('@/views/shsw/dzb/update'),
        meta: {title: '编辑电子报'},
        hidden:true
      },
      // ======================= 订阅管理相关路由 =======================
      {
        path: 'subscribe',
        name: 'DzbSubscribe',
        component: () => import('@/views/shsw/subscribe/index'),
        meta: { title: '订阅管理', icon: 'order' },  // 使用已知存在的图标
      },
      {
        path: 'subscribe/add',
        component: () => import('@/views/shsw/subscribe/add'),
        name: 'AddDzbSubscribe',
        meta: { title: '添加订阅' },
        hidden: true
      },
      {
        path: 'subscribe/update',
        component: () => import('@/views/shsw/subscribe/update'),
        name: 'UpdateDzbSubscribe',
        meta: { title: '编辑订阅' },
        hidden: true
      }
      // ==========================================================
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path:'/mem',
    component: Layout,
    redirect: '/mem/member',
    name: 'mem',
    meta: {title: '用户', icon: 'mem'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/mem/member/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js